import { Fragment, memo } from 'react';
import { splitHighlight } from 'src/utils/helpers';

const HighlightedText = ({ text, searchValue, fallback = '-' }) => {
  const parts = splitHighlight(text, searchValue);

  if (!parts.length) {
    return fallback;
  }

  return parts.map((part, index) =>
    part.match ? (
      <span key={index} className="highlight">
        {part.text}
      </span>
    ) : (
      <Fragment key={index}>{part.text}</Fragment>
    ),
  );
};

export default memo(HighlightedText);
